module.exports = __webpack_public_path__ + "img/safieScrn1.297cd8bb.png";